import { jsx as _jsx } from "react/jsx-runtime";
function ArrowUpRightFromSquare({ className, size = 24, }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 32 32", children: _jsx("path", { d: "M6.125 6.125H7.125H12.3598V8.125H8.125V22.8762H22.8762V18.6415H24.8762V23.8762V24.8762H23.8762H7.125H6.125V23.8762V7.125V6.125ZM21.462 8.125H15.5006V6.125H23.8762H24.8762V7.125V15.5006H22.8762V9.53921L16.2077 16.2077L14.7935 14.7935L21.462 8.125Z" }) }));
}
export default ArrowUpRightFromSquare;
